import { getQueryParam, removeUrlParameterFromAddressBar } from './utils';

type JumpQuery = {
    original_referrer: string;
    came_from: string;
};

let jumpQuery: JumpQuery | undefined = undefined;

/**
 * 获取跳转参数，并删除跳转参数。
 * @param notRemoveJumpParams 传入 true 时，不会删除 URL 参数
 * @returns 跳转参数
 */
export const getJumpQuery = (notRemoveJumpParams?: boolean) => {
    if (!jumpQuery) {
        jumpQuery = {
            original_referrer: getQueryParam('referrer'),
            came_from: getQueryParam('came_from'),
        };

        !notRemoveJumpParams && removeUrlParameterFromAddressBar(['referrer', 'came_from']);
    }

    return jumpQuery;
};
